export enum AttachmentType {
  IMAGE = 'IMAGE',
  DOC = 'DOC',
  VIDEO = 'VIDEO',
  ARCHIVE = 'ARCHIVE',
}
